<template>
  <nav aria-label="Page navigation" v-if="total > 0">
    <ul class="pagination justify-content-center flex-wrap">
      <!-- Botão Anterior -->
      <li class="page-item" :class="{ disabled: internalCurrentPage <= 1 }">
        <a class="page-link" href="#" @click.prevent="goToPage(internalCurrentPage - 1)">Anterior</a>
      </li>

      <!-- Páginas numeradas -->
      <li 
        v-for="page in displayedPages" 
        :key="page" 
        class="page-item" 
        :class="{ active: page === internalCurrentPage }"
      >
        <a class="page-link" href="#" @click.prevent="goToPage(page)">{{ page }}</a>
      </li>

      <!-- Botão Próxima -->
      <li class="page-item" :class="{ disabled: internalCurrentPage >= totalPages }">
        <a class="page-link" href="#" @click.prevent="goToPage(internalCurrentPage + 1)">Próxima</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    total: { type: Number, required: true },
    limit: { type: Number, default: 10 },
    offset: { type: Number, default: 1 }, // Este é o currentPage que vem do pai
    totalPages: { type: Number, default: 1 } // Adicionei esta prop para clareza
  },
  data() {
    return {
      internalCurrentPage: 1 // Mantemos um estado interno
    };
  },
   created() {
    console.group('Pagination Component Props Verification');
    console.log('total (total items):', this.total, typeof this.total);
    console.log('limit (items per page):', this.limit, typeof this.limit);
    console.log('offset (current page):', this.offset, typeof this.offset);
    console.log('totalPages:', this.totalPages, typeof this.totalPages);
    
    // Verificação adicional de valores
    if (this.total <= 0) {
      console.warn('Prop "total" deve ser maior que 0. Valor recebido:', this.total);
    }
    
    if (this.offset < 1) {
      console.warn('Prop "offset" deve ser pelo menos 1. Valor recebido:', this.offset);
    }
    
    // Calcula o total de páginas baseado em total e limit para comparar
    const calculatedPages = Math.ceil(this.total / this.limit);
    if (calculatedPages !== this.totalPages) {
      console.warn(`Discrepância no total de páginas! 
        Calculado: ${calculatedPages} | 
        Recebido: ${this.totalPages}`);
    }
    
    console.groupEnd();
  },
  computed: {
    displayedPages() {
      const pages = [];
      const startPage = Math.max(1, this.internalCurrentPage - 2);
      const endPage = Math.min(this.totalPages, startPage + 4);
      
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  watch: {
    // Sincroniza quando a prop offset muda
    offset: {
      immediate: true,
      handler(newVal) {
        this.internalCurrentPage = newVal;
      }
    }
  },
  methods: {
    goToPage(page) {
      page = Math.max(1, Math.min(page, this.totalPages));
      
      if (page !== this.internalCurrentPage) {
        this.internalCurrentPage = page;
        this.$emit('change-page', page);
      }
    }
  }
};
</script>

